import { IReportingPeriodApplicantDocumentService } from "../../service/document/ReportingPeriodApplicantDocumentService";

export default class GetReportingPeriodApplicantDocumentsInteractor {
  private reportingPeriodApplicantDocumentService: IReportingPeriodApplicantDocumentService;

  constructor(reportingPeriodApplicantDocumentService) {
    this.reportingPeriodApplicantDocumentService = reportingPeriodApplicantDocumentService;
  }

  async execute(reportingPeriodApplicantId: number) {
    return this.reportingPeriodApplicantDocumentService.getReportingPeriodApplicantDocuments(
      reportingPeriodApplicantId
    );
  }
}
